import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { IRootReducerState } from 'state/reducers'
import navigation from 'utils-support/navigation'

type HandlerFn = <P>(props: P) => void
type Handler = HandlerFn | string

interface IWithRegionSwitchHandlerProps {
  selectedRegion?: string
}

interface IWithRegionSwitchHandlerState {
  key: number
}

interface WithRegionSwitchHandlerProps extends IWithRegionSwitchHandlerProps, RouteComponentProps<{}> {}

export const withRegionSwitchHandler = (handler?: Handler) => (WrappedComponent: React.ComponentType) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const mapStateToProps = (state: IRootReducerState) => ({
    selectedRegion: state.region.selectedRegion
  })

  const enhance = compose<WithRegionSwitchHandlerProps, any>(withRouter, connect(mapStateToProps))

  class WithRegionSwitchHandler extends React.Component<WithRegionSwitchHandlerProps, IWithRegionSwitchHandlerState> {
    static displayName = `WithRegionSwitchHandler(${displayName})`
    static WrappedComponent: React.ComponentType = WrappedComponent

    state = {
      key: 0
    }

    componentDidUpdate(prevProps: WithRegionSwitchHandlerProps) {
      const { selectedRegion, location } = this.props

      if (prevProps.selectedRegion === selectedRegion) {
        return
      }

      if (typeof handler === 'function') {
        return handler(this.props)
      }

      if (typeof handler === 'string' && location.pathname !== handler && selectedRegion !== '') {
        return navigation.push(handler)
      }

      this.setState(prevState => ({
        key: prevState.key + 1
      }))
    }

    render() {
      const { selectedRegion, ...rest } = this.props
      const { key } = this.state

      return <WrappedComponent key={key} {...rest} />
    }
  }

  return enhance(WithRegionSwitchHandler)
}

export default withRegionSwitchHandler
